import * as React from 'react';
import { LikeOrWatchGuest, LikeOrWatchPremium, LikeOrWatchFreePlan } from './LikeOrWatch';
import Button from '@material-ui/core/Button';
import Stack from '@mui/material/Stack';
import SettingsIcon from '@mui/icons-material/Settings';
import RefreshCompanyDataModal from './RefreshCompanyDataModal';

function LikeOrWatchOption({data} :any) {
  const user_state = data.user_state;

  if (user_state?.status == 'guest') {
    return <LikeOrWatchGuest />;
  } else if (user_state?.status == 'premium') {
    return <LikeOrWatchPremium id={data.ticker} stock_in_favorites={user_state?.stock_in_favorites} new_watchlists={user_state?.watchlists} />;
  } else if (user_state?.status == 'free_plan') {
    return <LikeOrWatchFreePlan />;
  } else {
    return <span/>
  }
}

function Price({data} :any) {
  const [refreshModalOpen, setRefreshModalOpen] = React.useState(false);
  const [refreshLoading, setRefreshLoading] = React.useState(false);
  const [refreshMessage, setRefreshMessage] = React.useState('');

  function refreshButtonClick() {
    setRefreshMessage('');
    setRefreshModalOpen(true);
  }

  function closeRefreshModal() {
    if (refreshLoading) {
      return;
    }
    setRefreshModalOpen(false);
  }

  function submitDataRefresh() {
    if (data?.user_state?.status === 'free_plan' || data?.user_state?.status === 'guest') {
      window.location.assign('/upgrade_to_continue');
      return;
    }

    setRefreshLoading(true);
    setRefreshMessage('');

    const csrfTokenElement = document.querySelector("meta[name='csrf-token']") as HTMLMetaElement | null;
    const csrfToken = csrfTokenElement?.content;

    fetch('/company_data_refresh', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(csrfToken ? { 'X-CSRF-Token': csrfToken } : {})
      },
      body: JSON.stringify({ ticker: data?.ticker })
    })
      .then(async (response) => {
        if (response.status === 403) {
          window.location.assign('/upgrade_to_continue');
          return;
        }

        if (!response.ok) {
          throw new Error('Unable to start refresh');
        }

        setRefreshMessage('Refresh request submitted. You will be notified when it is complete.');
        setRefreshModalOpen(false);
      })
      .catch(() => {
        setRefreshMessage('Could not start refresh right now. Please try again.');
      })
      .finally(() => {
        setRefreshLoading(false);
      });
  }

  return (
    <div className="col-lg-4 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">{data.ticker} <span className={ (data.delisted == true) ? 'badge-danger badge-pill' : ''}>{ (data.delisted == true) ? 'Delisted' : ''}</span></h4>
          <p className="card-description">
            < LikeOrWatchOption data={data} />
          </p>
          <p className="card-description">
            <Stack direction="row" spacing={2}>
              <Button size="small" variant="outlined" onClick={refreshButtonClick} startIcon={<SettingsIcon />}>
                Recompute Scores
              </Button>
            </Stack>
          </p>
          {refreshMessage && <p className="card-description">{refreshMessage}</p>}
          <RefreshCompanyDataModal
            open={refreshModalOpen}
            loading={refreshLoading}
            isPaidUser={data?.user_state?.status === 'premium'}
            onClose={closeRefreshModal}
            onConfirm={submitDataRefresh}
          />
          <p className="card-description"> Quote (USD)</p>
          <div className="table-responsive">
            <table className="table table-striped">
              <tbody>
                <tr>
                  <td>Latest Price</td>
                  <td>{data.latest_price}</td>
                </tr>
                <tr>
                  <td>Change</td>
                  <td>{data.change}</td>
                </tr>
                <tr>
                  <td>Change Percent</td>
                  <td style={{ color: data.change_percent_color }}><strong>{data.change_percent}</strong></td>
                </tr>
                <tr>
                  <td>Open</td>
                  <td>{data.open}</td>
                </tr>
                <tr>
                  <td>low</td>
                  <td>{data.low}</td>
                </tr>
                <tr>
                  <td>High</td>
                  <td>{data.high}</td>
                </tr>
                <tr>
                  <td>Previous Close</td>
                  <td>{data.previous_close}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Price;
